export default "__VITE_ASSET__DH9Eb5Bd__"